import tw, { styled } from 'twin.macro';

const MarkdownUnorderedListItem = styled.li`
  ${tw`py-1`}
`;

export default MarkdownUnorderedListItem;
